import { render, staticRenderFns } from "./AppAffiliates.vue?vue&type=template&id=6ec8f180"
import script from "./AppAffiliates.vue?vue&type=script&lang=ts"
export * from "./AppAffiliates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports